(function(w,d,$){
  'use strict';
  if (!$) return;

  var A = w.AT_Main = w.AT_Main || {};
  var resizeQueued = false;

  A.getWidthBrowser = function(){
    return w.innerWidth || (d.documentElement && d.documentElement.clientWidth) || (d.body && d.body.clientWidth) || 0;
  };

  A.checkLayout = function(){
    if ($('#checkLayout .visible-xs-block').css('display') === 'block') return 1;
    if ($('#checkLayout .visible-sm-block').css('display') === 'block') return 2;
    if ($('#checkLayout .visible-md-block').css('display') === 'block') return 3;
    if ($('#checkLayout .visible-lg-block').css('display') === 'block') return 4;
  };

  A.fixNoScroll = function(){
    var width = $(w).width();
    $('#page-body, .header-content, #page-body .mobile-version').css('width', width + 'px');
  };

  A.fixReturnScroll = function(){
    $('#page-body, .header-content, #page-body .mobile-version').attr('style', '');
  };

  A.toTopButton = function(){
    var button = $('#scroll-to-top');
    if (!button.length) return;
    var ticking = false;
    function update(){
      var top = w.pageYOffset || d.documentElement.scrollTop || 0;
      var height = w.innerHeight || d.documentElement.clientHeight || 0;
      var marker = top > 100 ? top + height / 2 : 1;
      button.removeClass('on off').addClass(marker < 1000 && marker < height ? 'off' : 'on');
    }
    function onScroll(){
      if (ticking) return;
      ticking = true;
      (w.requestAnimationFrame || function(cb){ return w.setTimeout(cb,16); })(function(){
        update();
        ticking = false;
      });
    }
    w.addEventListener('scroll', onScroll, { passive: true });
    update();
    button.off('click.iceProduct').on('click.iceProduct', function(e){
      e.preventDefault();
      $('body,html').animate({scrollTop:0},800,'swing');
    });
  };

  A.effectNavigation = function(){
    $('.horizontal-menu .navigation .navbar-collapse .main-nav>li').off('.iceProductNav')
      .on('mouseenter.iceProductNav', function(){
        $(this).find('>.dropdown-menu, >.dropdown-menu li >.dropdown-menu').addClass('fadeInUp animated');
      })
      .on('mouseleave.iceProductNav', function(){
        $(this).find('>.dropdown-menu, >.dropdown-menu li >.dropdown-menu').removeClass('fadeInUp animated');
      });

    $('.verticle-menu .navigation .navbar-collapse .main-nav>li').off('.iceProductNav')
      .on('mouseenter.iceProductNav', function(){
        $(this).find('>.dropdown-menu, >.dropdown-menu li >.dropdown-menu').addClass('fadeInRight animated');
      })
      .on('mouseleave.iceProductNav', function(){
        $(this).find('>.dropdown-menu, >.dropdown-menu li >.dropdown-menu').removeClass('fadeInRight animated');
      });

    $('.cart-target, .currency-block').off('.iceProductNav')
      .on('mouseenter.iceProductNav', function(){ $(this).find('>.dropdown-menu').addClass('fadeInUp animated'); })
      .on('mouseleave.iceProductNav', function(){ $(this).find('>.dropdown-menu').removeClass('fadeInUp animated'); });
  };

  A.fixButton = function(){
    $('.product-wrapper .product-head').each(function(){
      if ($(this).children().hasClass('wrapper-countdown')) $(this).find('.product-button').addClass('fix');
    });
    $('.shipping-title').off('click.iceProduct').on('click.iceProduct', function(){ $('.shipping').toggle(); });
  };

  A.menuOnMobile = function(){
    $('#page-body').off('click.iceProductMenu').on('click.iceProductMenu', function(){
      $('.menu-mobile').removeClass('opened');
      $('html,body').removeClass('menu-opened');
      A.fixReturnScroll();
    });

    $(d).off('click.iceProductMenu','[data-toggle=offcanvas]')
      .on('click.iceProductMenu','[data-toggle=offcanvas]',function(e){
        e.stopPropagation();
        A.fixNoScroll();
        $('.menu-mobile').toggleClass('opened');
        $('html,body').toggleClass('menu-opened');
      });

    $('.navbar .main-nav li').off('.iceProductHover')
      .on('mouseenter.iceProductHover', function(){ $(this).addClass('hover'); })
      .on('mouseleave.iceProductHover', function(){ $(this).removeClass('hover'); });

    $(d).off('click.iceProductMenu','.mobile-version .menu-mobile .main-nav .expand')
      .on('click.iceProductMenu','.mobile-version .menu-mobile .main-nav .expand',function(){
        var parent = $(this).parents('.dropdown').first();
        if (parent.hasClass('menu-mobile-open')) {
          parent.removeClass('menu-mobile-open');
          $(this).find('.visible-xs').removeClass('fa-minus').addClass('fa-plus');
        } else {
          parent.addClass('menu-mobile-open');
          $(this).find('.visible-xs').removeClass('fa-plus').addClass('fa-minus');
        }
      });
  };

  A.handleMenuMultiLine = function(){
    var outItem = '', down = false;
    $('.navbar-collapse .main-nav > li').off('.iceProductMulti')
      .on('mousemove.iceProductMulti', function(e){
        var target = $(e.currentTarget);
        if (down && outItem !== '') {
          outItem.addClass('hold');
          w.setTimeout(function(){
            if (outItem !== '') outItem.removeClass('hold');
            down = false;
            outItem = '';
          },500);
          if (outItem[0] === target[0] || outItem.offset().top === target.offset().top) {
            outItem.removeClass('hold');
            down = false;
            outItem = '';
          }
        } else {
          outItem = '';
        }
      })
      .on('mouseout.iceProductMulti', function(e){
        var target = $(e.currentTarget);
        if (e.pageY >= target.offset().top + 50) down = true;
        if (target.hasClass('dropdown') && outItem === '') outItem = target;
      });
  };

  A.swatch = function(){
    $('.swatch :radio').off('change.iceProductSwatch').on('change.iceProductSwatch', function(){
      var optionIndex = $(this).closest('.swatch').attr('data-option-index');
      var optionValue = $(this).val();
      $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
    });
  };

  A.refreshImage = function(){
    if (!$('#gallery-image').length) return;
    $('#product-image').off('click.iceProductImage', '.thumb-img').on('click.iceProductImage', '.thumb-img', function(){
      var current = $(this);
      if (!current.hasClass('active')) {
        var parent = current.parents('.product-image-inner');
        var srcOriginal = current.attr('data-zoom-image');
        var srcDisplay = current.attr('data-image');
        parent.find('.thumb-img').removeClass('active');
        current.addClass('active');
        parent.find('.featured-image').find('img').attr('data-zoom-image', srcOriginal).attr('src', srcDisplay);
      }
      return false;
    });
  };

  A.refreshZoom = function(){
    var zoomImage = $('.elevatezoom .zoom-image');
    if (!zoomImage.length || typeof $.fn.elevateZoom !== 'function') return;
    zoomImage.elevateZoom({
      gallery: 'gallery-image',
      galleryActiveClass: 'active',
      zoomType: 'lens',
      cursor: 'pointer',
      lensShape: 'round',
      lensSize: 300
    });
    zoomImage.off('click.iceProductZoom').on('click.iceProductZoom', function(){
      var ez = $('.elevatezoom .zoom-image').data('elevateZoom');
      if (ez && typeof ez.getGalleryList === 'function' && typeof $.fancybox === 'function') {
        $.fancybox(ez.getGalleryList(), {
          closeBtn: true,
          helpers: { title: null }
        });
      }
      return false;
    });
  };

  A.cartJS_handle = function(){
    $(d).off('cart.requestComplete.iceProduct').on('cart.requestComplete.iceProduct', function(event, cart){
      if (w.Shopify && typeof w.Shopify.onCartUpdate === 'function') {
        w.Shopify.onCartUpdate(cart || (w.CartJS && w.CartJS.cart) || {});
      }
    });
  };

  A.init = function(){
    A.toTopButton();
    A.effectNavigation();
    A.fixButton();
    A.menuOnMobile();
    A.handleMenuMultiLine();
    A.swatch();
    A.refreshImage();
    A.refreshZoom();
    A.cartJS_handle();
  };

  w.addEventListener('resize', function(){
    if (resizeQueued) return;
    resizeQueued = true;
    (w.requestAnimationFrame || function(cb){ return w.setTimeout(cb,16); })(function(){
      resizeQueued = false;
      if (A.getWidthBrowser() < 1024 && $('#top').hasClass('on')) {
        $('#top').prev().remove();
        $('#top').removeClass('on animated');
      }
      A.fixReturnScroll();
      if (A.checkLayout() !== 1 && $('.menu-mobile').hasClass('opened')) $('#page-body').trigger('click');
    });
  }, { passive: true });

  $(function(){
    A.init();
  });

  $(w).off('load.iceProduct').on('load.iceProduct', function(){
    var loader = $('#site-loader');
    if (loader.length) loader.delay(1000).fadeOut('slow');
  });
}(window,document,window.jQuery));
